/*
tabs
  - tab-navigation
    -- li
  - navigation-body
    -- tab
//*/
import $ from 'jquery';

let tab = null;

let removeAllActives = () => {
    if(tab == null)
        return;
    tab.find(".tab-navigation li").removeClass("active");
    tab.find(".navigation-body").removeClass("active").css({"max-height":0});
    tab.find(".navigation-body .tab").removeClass("active");
    tab.find(".body-shadow").removeClass("active");
}

let isActive = ($li) => {
    return $li != null && $li.hasClass("active");
}

let getElementHeight = ($element) => {
    $element.addClass("no-animations").css({"display":"block"});
    let height = $element.outerHeight();
    $element.css({"display":''}).removeClass("no-animations");
    return height;
}

let activateTab = ($li) => {
    if($li == null)
        return;

    $li.addClass("active");

    let tabToSelect = $li.data("select");
    let groupToOpen = $li.closest("ul.tab-navigation").data("open");

    let tabElement = tab.find(`#${tabToSelect}`);
    let groupElement = tab.find(`#${groupToOpen}`);

    let scrollHeight =  getElementHeight(tabElement);

    tabElement.addClass("active");
    groupElement.addClass("active").css({"max-height":`${scrollHeight}px`});
    tab.find(".body-shadow").addClass("active");
}

let initTabs = ($tabWrapper) => {
    tab = $tabWrapper;
    tab.on("click",".tab-navigation li", ({currentTarget}) => {
          let currentIsActive = isActive($(currentTarget).closest("li"));
          removeAllActives();
          if(!currentIsActive){
            activateTab($(currentTarget).closest("li")); 
          } 
      });
      tab.on("click",".navigation-body .close-button",({currentTarget}) => {
        removeAllActives();
      });
}

export default initTabs;